import React, { useState, useEffect } from 'react';
import { Header } from '../../common/Header/Header.jsx';
import {
  MemoizedOneOptionTableFilter,
  SearchInputWithSelector,
  SelectPerPage,
} from '../../common/Forms/Input/Input';
import { notify } from '../../../assets/helpers/toast';
import { salesRoles } from '../../../assets/helpers/roles.js';
import { dbHistoryService } from '../../../services/dbHistoryService.js';
import { useLocation, useHistory } from 'react-router-dom';
import { FilterDatePicker } from '../../common/Forms/Input/Input';
import moment from 'moment';
import { capitalize, displayChange } from '../../../assets/helpers/funciones';
import Pagination from '@material-ui/lab/Pagination';
import './UpdateHistory.scss';
import authService from '../../../services/authService.js';
import { updateHistoryAllowed } from '../../../assets/helpers/emails';
import { updateHistoryTableHeader } from '../../../assets/helpers/tables.js';
import { ActionButton } from '../../common/Buttons/Buttons.jsx';
import { LoadSpinner } from '../../common/LoadSpinner/LoadSpinner.jsx';

const itemsPerpage = [10, 25, 50, 100, 500];

export const UpdateHistory = () => {
  const location = useLocation();
  const user = authService?.getUser();
  const history = useHistory();
  const queryParams = new URLSearchParams(location.search);
  const type = queryParams.get('type');
  const [searchCategoryOption, setSearchCategoryOption] = useState('');
  const [updateHistoryTableOptions, setUpdateHistoryTableOptions] = useState(
    updateHistoryTableHeader
  );
  const [sellerOptions, setSellerOptions] = useState([]);
  const [assignedSellerOptions, setAssignedSellerOptions] = useState([]);
  const [modifiedFieldOptions, setModifiedFieldOptions] = useState([]);
  const [modifiedField, setModifiedField] = useState('');
  const [seller, setSeller] = useState('');
  const [assignedSeller, setAssignedSeller] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  if (!updateHistoryAllowed.includes(user?.email) && !type) {
    notify('No tienes permiso para acceder a esta sección.', 'error');
    history.push('/dashboard');
  }

  const [editHistory, setEditHistory] = useState({
    isOpen: false,
    limit: itemsPerpage[0],
    offset: 0, //Elementos que ya pasaron la pagina
    data: [],
    count: 0, //Cantidad de elementos
    page: 1,
    dateFrom: moment(new Date()).subtract(7, 'days').format('YYYY-MM-DD'),
    dateTo: moment(new Date()).format('YYYY-MM-DD'),
    isLoading: true,
    searchParam: '',
  });

  const handleDateFrom = (e) => {
    setEditHistory((prevState) => {
      return {
        ...prevState,
        dateFrom: e,
      };
    });
  };
  const handleDateTo = (e) => {
    setEditHistory((prevState) => {
      return {
        ...prevState,
        dateTo: e,
      };
    });
  };

  const handleSelectedSeller = (str) => {
    setSeller(str);
  };

  const handleAssignedSeller = (str) => {
    setAssignedSeller(str);
  };

  const handleModifiedField = (str) => {
    setModifiedField(str);
  };

  const selectitemsPerpage = (event) => {
    setEditHistory((prevState) => {
      return {
        ...prevState,
        page: 1,
        offset: 0,
        limit: parseInt(event.target.value),
      };
    });
  };

  const handlePageChange = (event, value) => {
    setEditHistory((prevState) => {
      return {
        ...prevState,
        page: value,
        offset: (value - 1) * editHistory?.limit,
      };
    });
  };

  const handleSearchChange = (event) => {
    setEditHistory((prevState) => {
      return {
        ...prevState,
        searchParam: event?.target?.value,
        page: 1,
        offset: 0,
      };
    });
  };

  const handleSellerOptions = (arr) => {
    let data = [];
    for (let i = 0; i < arr.length; i++) {
      data?.push({
        _id: arr[i]?._id,
        name:
          capitalize(arr[i]?.firstName) + '  ' + capitalize(arr[i]?.lastName),
      });
    }
    setSellerOptions(data);
  };

  const handleAssignedSellerOptions = (arr) => {
    let data = [];
    for (let i = 0; i < arr.length; i++) {
      data?.push({
        _id: arr[i]?._id,
        name:
          capitalize(arr[i]?.firstName) + '  ' + capitalize(arr[i]?.lastName),
      });
    }
    setAssignedSellerOptions(data);
  };

  const handleModifiedFieldOptions = (arr) => {
    let data = [];
    for (let i = 0; i < arr.length; i++) {
      data?.push({
        _id: arr[i],
        name: arr[i],
      });
    }
    setModifiedFieldOptions(data);
  };

  const cleanFilters = () => {
    setEditHistory((prevState) => {
      return {
        ...prevState,
        searchParam: '',
      };
    });
    setSearchCategoryOption('');
    setSeller('');
    setAssignedSeller('');
    setModifiedField('');
    getHistory();
  };

  const getHistory = (byEmail) => {
    let params = {
      page: editHistory?.page,
      limit: editHistory?.limit,
      from: moment(editHistory?.dateFrom).format('YYYY-MM-DD'),
      to: moment(editHistory?.dateTo).format('YYYY-MM-DD'),
    };

    // compare dates if the diference is more than 7 days notify user and return in spanish
    const dateFrom = moment(editHistory?.dateFrom);
    const dateTo = moment(editHistory?.dateTo);
    const diffDays = dateTo.diff(dateFrom, 'days');

    if (diffDays > 7 && !byEmail) {
      notify(
        'El rango de fechas no puede ser mayor a 7 días, por favor seleccione un rango de fechas menor.',
        'info'
      );
      setIsLoading(false);
      return;
    }

    if (type) {
      params.module = type;
    }

    if (searchCategoryOption) {
      params.search = editHistory?.searchParam;
    }

    if (assignedSeller) {
      params.originalSeller = assignedSeller;
    }

    if (seller) {
      params.userId = seller;
    }

    if (modifiedField) {
      params.modifiedField = modifiedField;
    }

    if (byEmail) {
      params.byEmail = true;
    }
    setIsLoading(true);

    dbHistoryService
      .getMembershipHistory('', params)
      .then((response) => {
        if ([200, 201].includes(response?.status)) {
          if (byEmail) {
            setIsLoading(false);
            notify(
              `Solicitud de exportable realizada, espere a recibir un correo con el archivo correspondiente`,
              'info'
            );
            // return;
          } else {
            if (editHistory?.page === 1) {
              handleSellerOptions(response?.data?.filters?.[0].seller);
              handleAssignedSellerOptions(
                response?.data?.filters?.[0].memOriginalSeller
              );
              handleModifiedFieldOptions(response?.data?.filters?.[0].field);
            }
            setEditHistory((prevState) => {
              return {
                ...prevState,
                data: response?.data?.history,
                count: response?.data?.total,
              };
            });
            setIsLoading(false);
          }
        } else {
          notify(`${response.message}`, 'error');
          setIsLoading(false);
        }
      })
      .catch(() => {
        setIsLoading(false);
      });
  };

  const handleHeaderFilters = () => {
    const header = updateHistoryTableHeader.map((h) => ({ ...h }));

    header.forEach((header) => {
      if (header.name === 'Asesor') {
        header.filterOptions = sellerOptions;
        header.filterSearch = handleSelectedSeller;
        header.sortable = true;
      } else if (header.name === 'Asesor Responsable') {
        header.filterOptions = assignedSellerOptions;
        header.filterSearch = handleAssignedSeller;
        header.sortable = true;
      } else if (header.name === 'Campo modificado') {
        header.filterOptions = modifiedFieldOptions;
        header.filterSearch = handleModifiedField;
        header.sortable = true;
      } else {
        delete header.filterSearch;
      }
    });
    setUpdateHistoryTableOptions(header);
  };

  useEffect(() => {
    if (
      sellerOptions.length > 0 ||
      assignedSellerOptions.length > 0 ||
      modifiedFieldOptions.length > 0
    ) {
      handleHeaderFilters();
    }
  }, [sellerOptions, assignedSellerOptions, modifiedFieldOptions]);

  useEffect(() => {
    getHistory();
  }, [
    editHistory?.page,
    editHistory?.offset,
    editHistory?.limit,
    editHistory?.type,
    editHistory?.dateFrom,
    editHistory?.dateTo,
    seller,
    assignedSeller,
    modifiedField,
  ]);

  return (
    <>
      <Header />
      <LoadSpinner show={isLoading} />
      <div className="service-with-container container">
        <div className="buttons-container">
          <h1 className="title-component">
            Historial de Actualizaciones: {editHistory?.count}
          </h1>
          <ActionButton
            label={'Exportar'}
            action={() => {
              getHistory(true);
            }}
          />
        </div>
        <div className="breadcrumb-container">
          <div
            style={{
              width: '100%',
              display: 'flex',
              gap: '5px',
              justifyContent: 'end',
            }}
          >
            <ActionButton
              label={'Limpiar Filtros'}
              action={() => cleanFilters()}
            />
          </div>
          <div className="exportables-buttons-container">
            <div style={{ width: '100%' }} className="row">
              <>
                <div className="col-12 col-md-4" style={{ marginTop: '5px' }}>
                  <SearchInputWithSelector
                    placeholder={'Buscar por...'}
                    label={'Buscar'}
                    searchAction={getHistory}
                    value={editHistory?.searchParam}
                    onChange={handleSearchChange}
                    width="30px"
                    options={[
                      { _id: 'orderNumber', name: 'Orden #' },
                      { _id: 'identification', name: 'Cédula' },
                      { _id: 'plate', name: 'Placa' },
                    ]}
                    setCategory={setSearchCategoryOption}
                    category={searchCategoryOption}
                  />
                </div>
                <FilterDatePicker
                  bootstrap={'col-12 col-md-2'}
                  label={'Desde'}
                  type={'date'}
                  name={'dateFrom'}
                  placeholder={''}
                  onChange={handleDateFrom}
                  value={new Date(editHistory?.dateFrom)}
                />
                <FilterDatePicker
                  bootstrap={'col-12 col-md-2'}
                  label={'Hasta'}
                  type={'date'}
                  name={'dateTo'}
                  placeholder={''}
                  onChange={handleDateTo}
                  value={new Date(editHistory?.dateTo)}
                />
              </>
              <div
                style={{
                  marginTop: '24px',
                  marginLeft: 'auto',
                  width: '350px',
                }}
              >
                {![
                  salesRoles?.SALES_FARMER,
                  salesRoles?.SALES_HUNTER,
                  salesRoles?.SALES_COUNTER,
                  salesRoles?.SALES_ADMIN_AUX,
                  salesRoles?.SALES_KEY_ACCOUNTS,
                ].includes(authService?.getUserType()) && (
                    <SelectPerPage
                      label={'Registros por página'}
                      options={itemsPerpage}
                      value={editHistory?.limit}
                      onChange={selectitemsPerpage}
                    />
                  )}
              </div>
            </div>
          </div>
        </div>
        <table style={{ textAlign: 'center' }} className="table">
          <thead>
            <tr>
              {updateHistoryTableOptions?.map((h) => (
                <td
                  key={`${h?.name}-renewal`}
                  style={{
                    padding: '4px 8px 4px 8px',
                    textAlign: 'center',
                    justifyContent: 'center',
                    alignItems: 'center',
                    alignContent: 'center',
                  }}
                >
                  <div
                    style={{
                      display: 'flex',
                      flexDirection: 'row',
                      gap: '7px',
                      width: '100%',
                      textAlign: 'center',
                      justifyContent: 'center',
                      alignItems: 'center',
                      alignContent: 'center',
                    }}
                  >
                    {h?.sortable ? (
                      <MemoizedOneOptionTableFilter
                        label={h.name}
                        options={h.filterOptions}
                        onChange={h.filterSearch}
                      />
                    ) : (
                      h?.name
                    )}
                  </div>
                </td>
              ))}
            </tr>
          </thead>
          <tbody>
            {editHistory?.data?.length > 0 &&
              editHistory?.data?.map((d) =>
                d?.changes?.map((c, idx) => (
                  <tr key={d?._id + '-' + idx}>
                    {/* Solo muestra los datos generales en la primera fila de cada grupo de cambios */}
                    {idx === 0 ? (
                      <>
                        <td rowSpan={d.changes.length}>
                          {d?.date
                            ? moment(d?.date).format('DD/MM/YYYY LTS')
                            : ''}
                        </td>
                        <td rowSpan={d.changes.length}>
                          {capitalize(d?.user?.firstName) +
                            ' ' +
                            capitalize(d?.user?.lastName)}
                        </td>
                        <td rowSpan={d.changes.length}>
                          {d?.memId?.membershipId}
                        </td>
                        <td rowSpan={d.changes.length}>
                          {d?.originalSeller
                            ? capitalize(d?.originalSeller?.firstName) +
                            ' ' +
                            capitalize(d?.originalSeller?.lastName)
                            : ''}
                        </td>
                      </>
                    ) : null}
                    <td>{c?.field}</td>
                    <td
                      style={{
                        whiteSpace: 'pre',
                        // wordBreak: 'break-word',
                        textAlign: 'center',
                        maxWidth: '400px',
                        // textOverflow: 'ellipsis',
                        border: '0px solid transparent',
                      }}
                    >
                      {displayChange(c, c?.field, 'from')}
                    </td>
                    <td
                      style={{
                        whiteSpace: 'pre',
                        // wordBreak: 'break-word',
                        textAlign: 'center',
                        maxWidth: '400px',
                        // textOverflow: 'ellipsis',
                        border: '0px solid transparent',
                      }}
                    >
                      {displayChange(c, c?.field, 'to')}
                    </td>
                  </tr>
                ))
              )}
            {editHistory?.data?.length === 0 && (
              <tr>
                <td colSpan="7">No hay registros</td>
              </tr>
            )}
          </tbody>
        </table>
        <div className="pagination-container">
          <Pagination
            count={Math.ceil(editHistory?.count / editHistory?.limit)}
            variant="outlined"
            shape="rounded"
            page={editHistory?.page}
            onChange={handlePageChange}
          />
        </div>
      </div>
    </>
  );
};
